import { render, staticRenderFns } from "./forgetThird.vue?vue&type=template&id=7d635223&"
import script from "./forgetThird.vue?vue&type=script&lang=js&"
export * from "./forgetThird.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports